#include <packing>

float readDepth(sampler2D depthSampler, vec2 coord, float camNear, float camFar) {
	float fragCoordZ = texture2D(depthSampler, coord).x;
	float viewZ = perspectiveDepthToViewZ(fragCoordZ, camNear, camFar);
	return viewZToOrthographicDepth(viewZ, camNear, camFar);
}

float map(float value, float min1, float max1, float min2, float max2) {
	return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
}

vec3 blurDirectionally(sampler2D tex, float d, vec2 coord, float att, int samps, float p, vec2 dir, vec2 pSize) {
	vec3 c = vec3(0.);

	// screen space distance between sample points
    float b = pow(float(samps), p);

	// random attempts to scale down streak length by distance (depth buffer)
	b = abs(b + (pow(d, float(p))));

	// Sample neighboring pixels
    for (int s = 0; s < samps; s++) {
		// Weight = a^(b*s)
        float weight = pow(att, b * float(s));

		// Streak direction is a 2D vector in image space	
        vec2 sCoord = coord + (dir * b * vec2(s, s) * pSize);

		// 'Scale down' with each iteration and accumulate
        c += texture2D(tex, sCoord).rgb * clamp(weight, 0., 1.);
    }

	return clamp(c, vec3(0.), vec3(1.));
}

// TODO  ass in define ?
#define samples 4
#define directionCount 2

uniform sampler2D inputBuffer;
uniform sampler2D depthBuffer;
uniform sampler2D normalTex;
uniform float cameraNear;
uniform float cameraFar;
uniform float attenuation;
uniform vec2 pixelSize;
uniform float pass;
uniform vec2 direction;


varying vec2 vUv;

// TODO add as define or uniform?

void main() {
	vec4 inputTex = texture(inputBuffer, vUv);
	// pass out black where no effect takes place - pass is Additive, black equals no change to source 
	vec3 color = vec3(0.);
		
	// inputBuffer passes original buffer's color in .rgb, and passes the result of the highpass's selection in .a
	if (inputTex.a >= 0.9) {
        // TODO better? input texture. Here we sample a provided texture to modify direction (a 45 degree vec2) slightly, ideally breaking up uniform look of streaks.
		vec2 alterDirNormals = texture(normalTex, vUv).xy * .25;
		vec2 directionAltered = direction + alterDirNormals;

		// invert direction so streak-blur samples in both directions, see for loop below
		vec2 directions[directionCount] = vec2[directionCount](directionAltered, directionAltered * -1.);

        // 0.0 is at near plane, 1.0 at far plane
		float coordZ = readDepth(depthBuffer, vUv, cameraNear * 5., cameraFar / 15.);

		for (int dirIdx = 0; dirIdx < directionCount; dirIdx++) {
            // blur once in each direction, forming a line in opposing directions, originating from vUv. Subsequent passes 'move outwards' further.
			color += blurDirectionally(inputBuffer, coordZ, vUv, attenuation, samples, pass, directions[dirIdx], pixelSize);
            // decrease color contribution by one-minused highpass value
            color -= vec3(1. - inputTex.a);
		}
		// Divide color sum
		color /= float(directionCount);
	}
		
	gl_FragColor = vec4(color, 1.);
	// gl_FragColor = vec4(vec3(coordZ), 1.); // debug depthtexture view, move coordZ sampling outside of if()
}
